@use '@/styles/variables' as *;

.loader {
    width: 15px;
    aspect-ratio: 1;
    position: relative;
}

.loader::before,
.loader::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: $borderRadiusRound;
    background: $gray;
}

.loader::before {
    box-shadow: -25px 0 $gray;
    animation: l8-1 1s infinite linear;
}

.loader::after {
    transform: rotate(0deg) translateX(25px);
    animation: l8-2 1s infinite linear;
}

.pulse {
    width: 14px;
    aspect-ratio: 1;
    border-radius: $borderRadiusRound;
    animation: l5 1s infinite linear alternate;
}

@keyframes l8-1 {
    100% {
        transform: translateX(25px);
    }
}

@keyframes l8-2 {
    100% {
        transform: rotate(-180deg) translateX(25px);
    }
}

@keyframes l5 {
    0% {
        box-shadow:
            20px 0 $accent,
            -20px 0 $gray;
        background: $accent;
    }
    33% {
        box-shadow:
            20px 0 $accent,
            -20px 0 $gray;
        background: $gray;
    }
    66% {
        box-shadow:
            20px 0 $gray,
            -20px 0 $accent;
        background: $gray;
    }
    100% {
        box-shadow:
            20px 0 $gray,
            -20px 0 $accent;
        background: $accent;
    }
}
